import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { UserApi } from '../../shared/services/api/user.api';
import { CzlonekRodziny } from '../../shared/models/czlonek-rodziny';

export const familyMemberResolver: ResolveFn<Observable<CzlonekRodziny>> = (
  route: ActivatedRouteSnapshot,
): Observable<CzlonekRodziny> => {
  const userApi = inject(UserApi);
  const idParam = route.params['id'];
  return userApi.getFamilyMember$(idParam);
};
